import * as React from "react";
import styled from "styled-components";
import Placeholder from "../views/request/component/placeholder";
import { useHistory } from "react-router-dom";
import Table from "components/table";
import { CategoryTag } from "components/tag/index";
import { Status } from "components/status";
import { format } from "date-fns";
import { TRequest } from "types/request";
import { useTranslation } from 'react-i18next';
import { enUS, es } from "date-fns/locale";
import { useAuthContext } from "contexts/auth";
import convertCVD  from "utils/convertCVD";
import TooltippedElement from "components/TooltippedElement";

type Props = {
  data?: TRequest[] | null;
  type?: "property" | "customer";
};
export default function RequestsList({ data, type }: Props) {
  const { t, i18n } = useTranslation();
  const tBase = "containers.requestsList";
  const tr = (key: string) => t(`${tBase}.${key}`);
  const history = useHistory();
  const { cvd_type } = useAuthContext();

  const sortedData = React.useMemo(() => {
    if (!data?.length) return data ?? null;
    return [...data].sort((a, b) => Number(b.id) - Number(a.id));
  }, [data]);

  const handleClick = (row: any) => {
    history.push(`/requests/${row.id}`);
  };

  const locale = i18n.language === "es" ? es : enUS;

  const baseColumnsStart = {
    id: {
      label: tr("Request #"),
    },
    status: {
      label: tr("Status"),
      cell: (row: any) => {
        const statusColor = convertCVD(row.status_color, cvd_type);
        return <Status color={statusColor}>{tr(row.status)}</Status>
      }
    },
    link: {
      label: tr("Category"),
      cell: (row: any) => <CategoryTag>{row.link}</CategoryTag>,
    },
    description: {
      label: tr("Description"),
      cell: (row: any) => (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <TooltippedElement
            message={row.description}
            placement="bottom"
            element={
              <div className="truncate w-full overflow-hidden">
                {row.description}
              </div>
            }
          />
        </div>
      ),
      width: "15em",
      minWidth: "15em",
      maxWidth: "15em",
      style: {
        maxWidth: "15em",
      }
    },
  };

  const baseColumnsEnd = {
    address: {
      label: tr("Address"),
      width: "100%",
    },
    entry_date: {
      label: tr("Date"),
      cell: (row: any) =>
        format(new Date(row.entry_date), "MMM dd, yyyy hh:mm aa", {
          locale: locale,
        }),
      minWidth: "200px",
    },
  }

  // Add name column only if type is not "customer"
  const nameColumn = type !== "customer" ? {
    name: {
      label: tr("Name"),
      cell: (row: any) => <div>{row.name}</div>
    }
  } : {};

  const columns = {
    ...baseColumnsStart,
    ...nameColumn,
    ...baseColumnsEnd
  };

  return (
    <div>
      {data && data.length > 0 ? (
        <Table columns={columns} data={sortedData} handleClick={handleClick} />
      ) : (
        <Placeholder
          type="job"
          header={tr("No requests yet.")}
          label={tr("Requests will appear here when added.")}
        />
      )}
    </div>
  );
}

const Con = styled.div``;
